import { createApp } from 'vue';
import { setup as DataDogSetup } from '@ilteducation/datadog';
import posthogPlugin, { PluginOptions } from '@ilteducation/posthog';
import pinia from '@/plugins/pinia';
import i18n from '@/plugins/translation';
import stonlyPlugin from '@ilteducation/stonly';
import store from './store';
import App from './App.vue';
import router from './router';
import createVuetify from './plugins/vuetify';
import interceptorsSetup from './foundations/helpers/interceptors';
import { createHead } from '@unhead/vue';

interceptorsSetup();

DataDogSetup({
  applicationId: process.env.VITE_DD_APPLICATION_ID,
  clientToken: process.env.VITE_DD_CLIENT_TOKEN,

  environment: process.env.VITE_ENVIRONMENT!,

  service: process.env.VITE_DD_SERVICE!,
  sampleRate: process.env.VITE_ENVIRONMENT !== 'production' ? 100 : 10,
  version: store.getters.appVersion,
});

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(store);
app.use(i18n);
app.use(createHead());

if (import.meta.env.VITE_ENVIRONMENT === 'production' || import.meta.env.VITE_ENVIRONMENT === 'staging') {
  // only use in prod/staging
  app.use(stonlyPlugin, { wid: import.meta.env.VITE_STONLY_WID });
}
if (import.meta.env.VITE_ENVIRONMENT === 'production') {
  const apiKey: string = import.meta.env.VITE_POSTHOG_API_KEY;
  app.use(posthogPlugin, {
    apiKey,
    router,
    config: {
      autocapture: false,
      capture_pageview: false, // disabled because of cost for monthly events
      capture_pageleave: false, // disabled because of cost for monthly events
    },
  } as PluginOptions);
}
app.config.globalProperties.$store = store;

createVuetify().then((vuetify) => {
  app.use(vuetify);
  app.mount('#app');
});
